import React from "react";
import DialogContent from "@mui/material/DialogContent";
import SSELogo from "../../../../../../../../../images/iconeSSE.svg";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { Box, Typography } from "@mui/material";
import moment from "moment";

const SignatureDialog = ({ open, onClose, data }) => {
  const signature = data.assinaturas[0];

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <img src={SSELogo} alt={""} style={{ alignSelf: "flex-start" }} />
      <DialogContent style={{ display: "flex", flexDirection: "row" }}>
        <Box style={{ textAlign: "center" }}>
          <Typography id="modal-modal-title" variant="body1" mb={2}>
            Eu,{" "}
            <span style={{ fontWeight: 700 }}>
              {data?.empreendedor.respondente?.nome}
            </span>
            , declaro que recebi a visita gratuita de um representante de
            empresa credenciada pelo Sebrae no meu estabelecimento comercial em{" "}
            <span style={{ fontWeight: 700 }}>
              {moment(data?.dataAtendimento).format("DD/MM/YYYY")}
            </span>
            .
          </Typography>
          <img src={signature.urlConteudo} alt={""} />
          <Typography id="modal-modal-cnpj" variant="body2" mt={1}>
            Confirmação da visita - {data?.empreendedor.cnpj}
          </Typography>
          <Typography id="modal-modal-hash" color={"GrayText"} variant="body2">
            Assinado digitalmente com a hash {signature.nome}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignatureDialog;
